angular.module('bmsApp.settings')
	.factory('SatisfactionNoteSvc',
		function (
			CRUDSvc, SATISFACTION_NOTE_API) {
		return {
			read: function () {return CRUDSvc.get(SATISFACTION_NOTE_API.READ);},
			save: function (data) {return CRUDSvc.post(SATISFACTION_NOTE_API.SAVE, data);},

		};
	})
	.constant('SATISFACTION_NOTE_API', {
	READ: 'api/settings/satisfaction-note/read',
	SAVE: 'api/settings/satisfaction-note/save',
});
